import { m } from '@aimfora/i18n'
import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { GradingPage } from '~/components/grading/grading-page'
import { getGradingOverviewFn } from '~/functions/grading.functions'
import { gradingKeys, scopeOf } from '~/lib/query-keys'

// The trailing underscore keeps this page out of the exam page's layout: it is a page of its own
export const Route = createFileRoute('/_authed/app/exams/$examId_/grading')({
  // What is shown and in which order is in the address, so coming back from a result keeps it
  validateSearch: z.object({
    view: z.enum(['all', 'attention', 'open', 'approved']).catch('all').default('all'),
    sort: z.enum(['number', 'review']).catch('number').default('number'),
  }),
  head: () => ({ meta: [{ title: `${m.grading_title()} - ${m.app_name()}` }] }),
  // A missing exam, and one the caller may not see, both end in the "not found" page
  loader: ({ context, params }) =>
    context.queryClient.ensureQueryData({
      queryKey: gradingKeys.overview(scopeOf(context.session), params.examId),
      queryFn: () => getGradingOverviewFn({ data: { examId: params.examId } }),
    }),
  component: GradingRoute,
})

function GradingRoute() {
  const { examId } = Route.useParams()
  const { view, sort } = Route.useSearch()
  const navigate = Route.useNavigate()
  return (
    <GradingPage
      examId={examId}
      view={view}
      sort={sort}
      onShow={(next) =>
        void navigate({ search: (previous) => ({ ...previous, ...next }), replace: true })
      }
    />
  )
}
